<template>
	<div
		@click="selectItem"
		@mouseover="onHover"
		ref="menu_list_item_container"
		@mouseleave="isHovered = false"
		:class="{ 'is-focused': isFocused, disabled: disabled, 'focused-background': isHovered || isFocused }"
		class="menu-list-item-container width-100 display-flex flex-row flex-align-center pl-1 pr-3 flex-justify-space-between"
	>
		<div class="display-flex flex-row flex-align-center">
			<div :class="{ disabled: disabled }" class="icon-and-title-container display-flex flex-row flex-align-center">
				<InsertDataPreviewIcon :iconName="nodeInfo.serviceSlug" class="mr-1" />
				<div class="title-container">{{ title }}</div>
			</div>
			<div v-if="disabled" class="display-flex flex-row ml-1">
				<AppTooltip top v-if="!isItemTestedSuccessfully" :text="noSampleDataError">
					<IconWarning class="warning-icon" />
				</AppTooltip>
				<AppTooltip v-else-if="disabledBecauseNoTable" top :text="noTableError">
					<v-icon class="no-table-icon">mdi-table-off</v-icon>
				</AppTooltip>
			</div>
		</div>
		<v-icon v-if="isHovered || isFocused" class="chevron-icon">mdi-chevron-right</v-icon>
	</div>
</template>

<script>
import AppTooltip from '@/components/common/AppTooltip';
import IconWarning from '@/components/FlowTreeBlock/assets/icon-exclamation-unknown.svg';
import InsertDataPreviewIcon from '@/components/DataInput/DataInputMenu/InsertDataPreviewIcon';
import DataInputMenuService from '@/components/DataInput/DataInputMenu/data-input-menu-service';

export default {
	name: 'MenuListItem',
	components: { AppTooltip, IconWarning, InsertDataPreviewIcon },
	props: {
		item: { type: Object },
		index: { type: Number },
		disabled: { type: Boolean },
		focusedMenuItemKey: { type: String },
		disabledBecauseNoTable: { type: Boolean },
		isItemTestedSuccessfully: { type: Boolean },
		addIndex: { type: Boolean, default: true },
	},
	computed: {
		nodeInfo() {
			return this.item.nodeInfo;
		},
		title() {
			return this.addIndex ? `${this.index + 1}. ${this.nodeInfo.nodeTitle}` : this.nodeInfo.nodeTitle;
		},
		menuItemUniqueKey() {
			return DataInputMenuService.getMenuItemUniqueKey(this.item);
		},
		isFocused() {
			return this.focusedMenuItemKey === this.menuItemUniqueKey;
		},
		noSampleDataError() {
			return 'No Sample data. Test step to use data';
		},
		noTableError() {
			return 'No tables in this step';
		},
	},
	methods: {
		selectItem() {
			if (this.disabled) {
				return;
			}
			this.$emit('select-item', this.item.key);
		},
		onHover() {
			if (this.disabled) {
				return;
			}
			this.isHovered = true;
			// clear focused menu item if hovering on another TODO: check with product its necessary
			this.focusedMenuItemKey && this.$emit('focus-on-item', null);
		},
	},
	data() {
		return {
			isHovered: false,
		};
	},
	watch: {
		isFocused: {
			handler(newV) {
				newV && this.$emit('scroll-to-element', this.$refs.menu_list_item_container.getBoundingClientRect());
			},
		},
	},
};
</script>

<style scoped lang="scss">
.disabled {
	cursor: default;
}

.focused-background {
	background: var(--ask-for-ingreation-hover-background);
}

.menu-list-item-container {
	height: 25px;

	&:not(.disabled) {
		cursor: pointer;
	}

	.icon-and-title-container {
		font-size: 12px;
		color: var(--primary-font-color);

		.title-container {
			font-size: 12px;
			line-height: 20px;
			background: transparent;
			color: var(--primary-font-color);

			overflow: hidden;
			white-space: normal;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			text-overflow: ellipsis;
			-webkit-box-orient: vertical;
		}

		&.disabled {
			opacity: 0.4;
			cursor: auto;
		}
	}
	.chevron-icon {
		width: 0px;
		height: 0px;
		color: #5a677d;
		font-size: 18px;
	}
}
.warning-icon {
	cursor: pointer;
}
.no-table-icon {
	cursor: pointer;
	font-size: 16px;
	color: #939393;
}
</style>
